module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.performSynchronization($event)
      }
    }
  }, [_c('span', {
    class: ['glyphicon', 'glyphicon-refresh', {
      'spin': _vm.isLoading
    }]
  }), _vm._v("\n  " + _vm._s(_vm.$t('marker.ftp.synchronize')) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08130d50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marker/FTPSyncButton.vue
// module id = 1015
// module chunks = 1